import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common'
import { LoyaltyProgramKpi } from 'src/app/assabil-sales/models/dtos/loyalty-program-kpi';

@Component({
  selector: 'loyalty-program-kpi',
  templateUrl: './loyalty-program-kpi.component.html',
  styleUrls: ['./loyalty-program-kpi.component.scss']
})
export class LoyaltyProgramKpiComponent implements OnInit {

  @Input() geoArea    ;
  @Input() loyaltyProgramKpi : LoyaltyProgramKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod      : string;

  
  constructor(protected datepipe: DatePipe) { }

  ngOnInit() {
  }


  clickTitle()        { this.onClick.emit({loyaltyProgram : this.loyaltyProgramKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "Count"} );} 
  clickReturnsBonus() { this.onClick.emit({loyaltyProgram : this.loyaltyProgramKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "ReturnsBonus"} );} 
  clickAssetBonus()   { this.onClick.emit({loyaltyProgram : this.loyaltyProgramKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "AssetBonus"} );} 
  clickPerfBonus()    { this.onClick.emit({loyaltyProgram : this.loyaltyProgramKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "PerfBonus"} );} 
  clickSales()        { this.onClick.emit({loyaltyProgram : this.loyaltyProgramKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "Sales"} );} 
  clickReturns()      { this.onClick.emit({loyaltyProgram : this.loyaltyProgramKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "Returns"} );} 
  clickIncrease()     { this.onClick.emit({loyaltyProgram : this.loyaltyProgramKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "Increase"} );} 
  clickDecrease()     { this.onClick.emit({loyaltyProgram : this.loyaltyProgramKpi.loyaltyProgramCode, geoArea : this.geoArea, kpi : "Decrease"} );} 
  
  getDecreaseRate(loyaltyProgramKpi : LoyaltyProgramKpi) {
    return Math.round((loyaltyProgramKpi.totalCount !=0 ? (loyaltyProgramKpi.decreaseCount * 100 / loyaltyProgramKpi.totalCount) : 0));
  }
  getIncreaseRate(loyaltyProgramKpi : LoyaltyProgramKpi) {
    return Math.round((loyaltyProgramKpi.totalCount != 0 ? (loyaltyProgramKpi.increaseCount * 100 / loyaltyProgramKpi.totalCount) : 0));
  }
  getReturnsRate(loyaltyProgramKpi : LoyaltyProgramKpi) {
    return Math.round(( loyaltyProgramKpi.returnsBaseSalesAmount != 0 ? (loyaltyProgramKpi.returnsBaseReturnsAmount * 1000 / loyaltyProgramKpi.returnsBaseSalesAmount) : 0)) / 10;
  }
  getPerfBonusRate(loyaltyProgramKpi : LoyaltyProgramKpi) {
    return Math.round(( loyaltyProgramKpi.totalCount != 0 ? (loyaltyProgramKpi.perfBonusCount * 100 / loyaltyProgramKpi.totalCount) : 0));
  }
  getAssetBonusRate(loyaltyProgramKpi : LoyaltyProgramKpi) {
    return Math.round(( loyaltyProgramKpi.totalCount != 0 ? (loyaltyProgramKpi.assetBonusCount * 100 / loyaltyProgramKpi.totalCount) : 0));
  }
  getReturnsBonusRate(loyaltyProgramKpi : LoyaltyProgramKpi) {
    return Math.round( loyaltyProgramKpi.totalCount != 0 ? (loyaltyProgramKpi.returnsBonusCount * 100 / loyaltyProgramKpi.totalCount) : 0 );
  }
  getBoosterBonusRate(loyaltyProgramKpi : LoyaltyProgramKpi) {
    return Math.round( loyaltyProgramKpi.totalCount != 0 ? (loyaltyProgramKpi.boosterBonusCount * 100 / loyaltyProgramKpi.totalCount) : 0 );
  }

}